module.exports = __webpack_public_path__ + "img/2.315113f2.png";